<template>
    <div class="flex flex-col z-[99] relative" tabindex="0" @blur="close">
        <div class="flex flex-row justify-between items-center py-[5px]" :class="disabled?selectClass+' cursor-not-allowed':selectClass+' cursor-pointer'" @click="toggleOpen">
            <div class="flex " :class="selected?'text-white':'text-grey'">
                <span class="inline-block truncate pl-[10px]">{{selected?getName(selected):placeholder}}</span>
            </div>
            <div>
                <svg v-if="open" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.83008 0.624219L0.830078 6.62422L1.90508 7.69922L6.83008 2.74922L11.7551 7.67422L12.8301 6.59922L6.83008 0.624219Z" fill="white"/>
                </svg>
                <svg v-else width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.83325 7.37578L0.833252 1.37578L1.90825 0.300781L6.83325 5.25078L11.7583 0.325781L12.8333 1.40078L6.83325 7.37578Z" fill="white"/>
                </svg>
            </div>
        </div>
        <div v-if="open" class="flex flex-col z-[999] absolute max-h-96 overflow-auto w-[calc(100%_-_10px)]" :class="optionClass">
            <div @click="select(option.id)" :class="option.id==selected?'bg-[#425755] border-l-[4px] border-theme-green':'pl-[4px] border-t border-light-black bg-theme-modalbg'" class="relative flex flex-row gap-[8px] p-2 drop-shadow transition duration-500 hover:bg-theme-grey cursor-pointer" v-for="option in options" :key="'brd-'+option.id" :value="option.id">
                <div class="inline-block break-all">{{option.name}}</div>
            </div>
        </div>
    </div>
    </template>
    <script>
    import {defineComponent} from 'vue'
    export default defineComponent({
        props: {
            modelValue: String,
            placeholder:String,
            options: Array,
            disabled: Boolean,
            selectClass: String,
            optionClass: String
        },
        data(){
            return {
                open: false,
                selected: ''
            }
        },
        mounted(){
            this.selected = this.modelValue
        },
        watch: {
            modelValue(){
                this.selected = this.modelValue
            }
        },
        methods: {
            toggleOpen(){
                if(!this.disabled){
                    this.open = !this.open
                }
            },
            close(){
                this.open = false
            },
            isAdded(id){
                return this.selected.includes(id)
            },
            getName(id){
                if(!id) return
                
                if(id=='noCategory'){
                    return 'No Category'
                }else{
                    let obj = this.options.find(each => each.id==id)
                    if(obj) return obj.name
                }
            },
            getColor(id){
                let obj = this.options.find(each => each.id==id)
                if(obj) return obj.posColour
            },
            select(id){
                this.selected = id
                this.$emit('update:modelValue', this.selected)
                this.$emit('changed', this.selected)
                this.close()
            }
        }
    })
    </script>